
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_9597_1682)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_9597_1682)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 20v-9h12v9H6zM4 9h2c0-2.04.392-4.003 1.346-5.49C8.334 1.97 9.894 1 12 1s3.666.97 4.654 2.51C17.608 4.997 18 6.96 18 9h2v12a1 1 0 01-1 1H5a1 1 0 01-1-1V9zm12 0c0-1.827-.358-3.363-1.03-4.41C14.335 3.597 13.395 3 12 3c-1.394 0-2.334.597-2.97 1.59C8.357 5.637 8 7.173 8 9h8zm-3 7.732A2 2 0 0012 13a2 2 0 00-1 3.732V18h2v-1.268z","fill":"#161616","fill-opacity":".88"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_9597_1682"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_9597_1682"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    